import React, { createContext, useContext, useReducer } from 'react';

const initialState = { loggedIn: false, loading: true, error: false, update: 0 };

const ProfileStateContext = createContext();
const ProfileDispatchContext = createContext();

const ProfileReducer = (state, action) => {
    switch (action.type) {
        case 'LOGGED_IN':
            return { ...state, loggedIn: true };
        case 'LOADED':
            return { ...state, loading: false, error: false };
        case 'LOADING':
            return { ...state, loading: true, error: false };
        case 'ERROR':
            return { ...state, loading: false, error: true };
        case 'ADD_USER':
            return { ...state, user: { ...action.payload } };
        case 'ADD_ORGANISATION':
            return { ...state, organisation: { ...action.payload } };
        case 'ADD_ROLES':
            return { ...state, roles: [...action.payload] };
        case 'ADD_ORGANISATIONS':
            return { ...state, organisations: [...action.payload] };
        case 'ADD_ADDRESSES':
            return { ...state, addresses: [...action.payload] };
        case 'ADD_USERS':
            return { ...state, users: [...action.payload] };
        case 'RESET':
            return initialState;
        case 'UPDATE':
            return { ...state, update: state.update++ };
        default:
            console.error(`Unhandled action dispatched to profile reducer, action type was: ${action.type}`);
            return state;
    }
};

const ProfileProvider = ({ children }) => {
    const [state, dispatch] = useReducer(ProfileReducer, initialState);

    return (
        <ProfileStateContext.Provider value={state}>
            <ProfileDispatchContext.Provider value={dispatch}>
                {children}
            </ProfileDispatchContext.Provider>
        </ProfileStateContext.Provider>
    );
};

const useProfileState = () => {
    const context = useContext(ProfileStateContext);
    if (context === undefined) {
        throw new Error('useProfileState must be used within a ProfileContextProvider');
    }
    return context;
};

const useProfileDispatch = () => {
    const context = useContext(ProfileDispatchContext);
    if (context === undefined) {
        throw new Error('useProfileDispatch must be used within a ProfileContextProvider');
    }
    return context;
};

export { ProfileProvider, useProfileDispatch, useProfileState };
